import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MassiveRecordResponse } from '@models/massiveRecordResponse.model';
import { CONSTANTS } from '@config/constants';
import { ExonerationService } from '@services/exoneration.service';
import { PubSubService } from '@services/pubsub.service';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-massive-exoneration-status',
  templateUrl: './massive-exoneration-status.component.html',
  styleUrls: ['./massive-exoneration-status.component.scss'],
})
export class MassiveExonerationStatusComponent implements OnInit {
  @Output() operationType: EventEmitter<string> = new EventEmitter<string>();
  @Input() massiveResponse: Array<MassiveRecordResponse>;
  public massiveSucces: Array<MassiveRecordResponse>;
  public massiveError: Array<MassiveRecordResponse>;

  constructor(
    private auth: AuthService,
    public router: Router,
    public spinner: NgxSpinnerService,
    public exoneration: ExonerationService,
    private pubSubService: PubSubService
  ) {}

  ngOnInit() {
    this.pubSubService.sendMessage(true);
    this.massiveError = this.massiveResponse.filter(
      (massiveRecord: MassiveRecordResponse) =>
        massiveRecord.observation != CONSTANTS.OPERATIONS.EXONERATED
    );
    this.massiveSucces = this.massiveResponse.filter(
      (massiveRecord: MassiveRecordResponse) =>
        massiveRecord.observation == CONSTANTS.OPERATIONS.EXONERATED
    );
  }

  back() {
    this.operationType.emit('');
  }

  downloadTransactions(status: string) {
    if (status === 'Negada') {
      (window as any).gtag('event', 'descargue exitosos', {
        event_category: 'exoneracion-masiva',
        event_label: `${this.auth.identity.userInfo.documentType}:${this.auth.identity.userInfo.document}:1;${this.auth.identity.username}`,
      });
    } else {
      (window as any).gtag('event', 'descargue-exitosos', {
        event_category: 'exoneracion-masiva',
        event_label: `${this.auth.identity.userInfo.documentType}:${this.auth.identity.userInfo.document}:1;${this.auth.identity.username}`,
      });
    }
    const settled =
      this.massiveSucces.length > 0
        ? this.massiveSucces[0].radication
        : this.massiveError.length > 0
        ? this.massiveError[0].radication
        : '0';
    this.spinner.show();
    this.exoneration.exportMassiveResult(settled, status).subscribe(
      (res: any) => {
        const blob = new Blob([res], {
          type: 'application/ms-excel',
        });
        saveAs(blob, `${settled}-${status}` + '.xlsx');
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
  }
}
